import React, {Component} from 'react'
import {Col, DatePicker, Form, Input} from 'antd'
import {dateVal} from '../../../../../modules/Utils'
import withLoadingSection from '../../../../../elements/HOC/withLoadingSection'
import {compose} from 'recompose'
import {get} from 'lodash'

class DeliveryForm extends Component {
  render() {
    const {deliveryLine, orderLine} = this.props
    const {getFieldDecorator} = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 6},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 14, offset: 1},
      },
    }
    return (
      <Form>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Notes'}>
            {getFieldDecorator('notes', {
              initialValue: get(deliveryLine, 'notes'),
            })(<Input />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Delivery Date'}>
            {getFieldDecorator('date', {
              initialValue: dateVal(orderLine, 'pickup.date'),
              rules: [{required: true, message: 'Please Select a Date!'}],
            })(<DatePicker style={{width: '100%'}} />)}
          </Form.Item>
        </Col>
      </Form>
    )
  }
}

DeliveryForm.propTypes = {}
DeliveryForm.defaultProps = {}

export default compose(Form.create(), withLoadingSection)(DeliveryForm)
